(function ($) {
    function marquee() {
        const marquee = document.querySelectorAll('.marquee')

        if (!marquee) return

        marquee.forEach(item => {
            const marqueeInner = item.querySelector('.marquee__inner')
            const marqueeContent = marqueeInner.querySelector('.marquee__content')

            // Duration
            const duration = item.getAttribute('data-marquee-duration')

            // Element Clone
            const marqueeContentClone = marqueeContent.cloneNode(true)
            marqueeInner.append(marqueeContentClone)

            // Marquee animation
            const marqueeContentAll = marqueeInner.querySelectorAll('.marquee__content')
            marqueeContentAll.forEach(element => {
                gsap.to(element, {
                    x: "-101%",
                    repeat: -1,
                    duration: duration,
                    ease: 'linear'
                })
            })
        });
    }

    function playVideoHover() {
        const is_home = document.body.classList.contains('home');
        if (!is_home) {
            const items_wrap = document.querySelector('#collections .content');
            const items = items_wrap.querySelectorAll('.item__content-link .item');
            if (items.length > 0) {
                items.forEach((item) => {
                    let videoItem = item.querySelector('.item__cover video');
                    if (typeof videoItem != 'undefined') {
                        item.addEventListener('mouseenter', () => {
                            videoItem.play();
                            videoItem.playbackRate = 1.4;
                        });
                        item.addEventListener('mouseleave', () => {
                            videoItem.pause();
                            videoItem.plabackRate = 1.0;
                        });
                    }
                });
            }
        }


        if (is_home) {
            const items_wrap = document.querySelector('#demo .content');
            const items = items_wrap.querySelectorAll('.item__content-link .item');
            if (items.length > 0) {
                items.forEach((item) => {
                    let videoItem = item.querySelector('.item__cover video');
                    if (typeof videoItem != 'undefined') {
                        item.addEventListener('mouseenter', () => {
                            videoItem.play();
                            videoItem.playbackRate = 1.4;
                        });
                        item.addEventListener('mouseleave', () => {
                            videoItem.pause();
                            videoItem.plabackRate = 1.0;
                        });
                    }
                });
            }
        }
    }

    function managePreview() {
        const is_single = document.body.classList.contains('single');

        if (is_single) {
            const contents = document.querySelectorAll('#collections .content .item__content-link');
            contents.forEach((content) => {
                content.addEventListener('click', () => {
                    const contentID = content.id;
                    let parts = contentID.split("-");
                    let numberID = parts[1];

                    let relatedPreview = document.querySelector('#collections #preview-' + numberID);
                    let previewWrap = relatedPreview.querySelector('.preview__wrap');
                    let previewVideo = relatedPreview.querySelector('.preview__wrap video');
                    let previewClose = relatedPreview.querySelector('.preview-close');
                    let tlPreview = gsap.timeline({paused: true});
                    tlPreview.to(relatedPreview, {y: '0', duration: 1, ease: 'power3.inOut'}, 0);
                    tlPreview.fromTo(previewWrap,
                        {autoAlpha: 0},
                        {autoAlpha: 1, duration: 1.5, ease: 'power3.inOut'}, 0);
                    tlPreview.addPause();

                    previewVideo.play();

                    tlPreview.fromTo(previewWrap,
                        {autoAlpha: 1},
                        {autoAlpha: 0, duration: 1, ease: 'power3.inOut'}, 2);
                    tlPreview.to(relatedPreview, {y: '100%', duration: 1, ease: 'power3.inOut'}, 1.5);

                    tlPreview.play();


                    previewClose.addEventListener('click', () => {
                        tlPreview.play();
                        previewVideo.pause();
                    });
                });
            });
        }
    }

    function magicCursor() {
        const cursor = document.querySelector('.cursor');
        let anchors = document.querySelectorAll('a:not(.active)');
        let previews = document.querySelectorAll('.preview');
        const notActiveMenuItem = document.querySelector('nav a:not(.active)');

        let mouseX;
        let mouseY;

        window.addEventListener('mousemove', (e) => {
            mouseX = e.clientX;
            mouseY = e.clientY;
            gsap.to(cursor, 0.3, {opacity: 1, delay: 0.3});
            gsap.to(cursor, 0.15, {x: mouseX, y: mouseY});
        });

        document.addEventListener('mouseleave', (e) => {
            gsap.to(cursor, 0.3, {opacity: 0, delay: 0.3});
        });

        previews.forEach((preview) => {
            preview.addEventListener('mousemove', (e) => {
                gsap.to(cursor, 0.3, {backgroundColor: '#432975', delay: 0.1});
            });
            preview.addEventListener('mouseleave', () => {
                gsap.to(cursor, 0.3, {backgroundColor: '#FFFFFF', delay: 0.1});
            });
        });

        anchors.forEach((anchor) => {
           anchor.addEventListener('mouseenter', () => {
               gsap.to(cursor, 0.15, {scale: 2, transformOrigin: 'center center', backgroundColor: '#00D7B0', autoAlpha: 0.9});
           });
           anchor.addEventListener('mouseleave', () => {
               gsap.to(cursor, 0.15, {scale: 1, transformOrigin: 'center center', backgroundColor: '#FFFFFF', autoAlpha: 1});
           });
        });

        notActiveMenuItem.addEventListener('mouseenter', () => {
           gsap.to(cursor, {autoAlpha: 0, duration: 0.15});
        });

        notActiveMenuItem.addEventListener('mouseleave', () => {
           gsap.to(cursor, {autoAlpha: 1, duration: 0.15});
        });
    }

    function activePage() {
        const menuItemHome = document.querySelector('nav a#navigation-home');
        const menuItemCollections = document.querySelector('nav a#navigation-collections');

        if (document.body.classList.contains('home')) {
            menuItemHome.classList.add('active');
            menuItemCollections.classList.remove('active');
        } else {
            menuItemCollections.classList.add('active');
            menuItemHome.classList.remove('active');
        }

        menuItemHome.addEventListener('click', () => {
           menuItemHome.classList.remove('active');
            menuItemCollections.classList.add('active');
        });
        menuItemCollections.addEventListener('click', () => {
           menuItemHome.classList.add('active');
            menuItemCollections.classList.remove('active');
        });
    }

    const lenis = new Lenis();

    function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    const navMenu = document.querySelector('nav');
    const navEnter = gsap.timeline({
        paused: true,
        ease: 'power3.inOut',
    })
    navEnter.fromTo(navMenu, 0.4, { y: '200%', autoAlpha: 0}, {y:0, autoAlpha: 1});
    navEnter.restart();

    const options = [
        {
            from: '(.*)',
            to: '(.*)',
            in: (next) => {
                document.querySelector('#swup').style.opacity = 0;
                gsap.to(document.querySelector('#swup'), 0.5, {
                    opacity: 1,
                    onComplete: next
                });
            },
            out: (next) => {
                document.querySelector('#swup').style.opacity = 1;
                const tlLeavePage = gsap.timeline();
                tlLeavePage.to(".loading-screen", {
                    duration: 0.5,
                    width: "100%",
                    left: "0%",
                    ease: "Expo.easeInOut",
                    onComplete: next
                });
                navEnter.reverse();
                tlLeavePage.to(".loading-screen", {
                    duration: 0.4,
                    width: "100%",
                    left: "100%",
                    ease: "Expo.easeInOut",
                    delay: 0.3,
                    onComplete:  function () { navEnter.restart(); }
                });
                tlLeavePage.set(".loading-screen", { left: "-100%" });
            }
        }
    ];

    const swup = new Swup({
        plugins: [
            new SwupBodyClassPlugin(),
            new SwupHeadPlugin(),
            new SwupJsPlugin(options),
        ]
    });

    $(document).on('ready', function () {
        marquee();
        playVideoHover();
        managePreview();
        magicCursor();
        activePage();
        window.lazyLoadInstance = new LazyLoad({
            elements_selector: ".lazy",
            threshold: 100
        });
    });

    swup.hooks.on('page:view', () => {
        // This runs after every page change by swup
        requestAnimationFrame(raf);
        playVideoHover();
        managePreview();
        marquee();
        magicCursor();
        activePage();
        window.lazyLoadInstance = new LazyLoad({
            elements_selector: ".lazy",
            threshold: 100
        });
    });
})
(jQuery);